import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-19392a55"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "hm__elm"
}
const _hoisted_2 = { class: "hm__elm-logo" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 1,
  class: "hm__elm-profile"
}
const _hoisted_5 = {
  key: 1,
  class: "hm__appear"
}
const _hoisted_6 = { class: "hm__appear-arrow" }
const _hoisted_7 = { class: "hm__appear-search" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "hm__appear-search-input",
  placeholder: "Найти инстанс"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowLeft = _resolveComponent("IconArrowLeft")!
  const _component_IconLogo = _resolveComponent("IconLogo")!
  const _component_IconLogoTapi = _resolveComponent("IconLogoTapi")!
  const _component_IconProfile = _resolveComponent("IconProfile")!
  const _component_IconInputSearch = _resolveComponent("IconInputSearch")!
  const _component_ModalHeaderNotify = _resolveComponent("ModalHeaderNotify")!
  const _component_ModalBottomProfile = _resolveComponent("ModalBottomProfile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "hm",
      style: _normalizeStyle(
			_ctx.isAuth
				? '--template-columns: 1fr 0.1fr'
				: '--template-columns: 1fr 0.1fr'
		)
    }, [
      (!_ctx.isShowSearch)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (
						_ctx.currentRouteName !== 'instances' &&
						_ctx.currentRouteName !== 'registration' &&
						_ctx.currentRouteName !== 'login'
					)
                ? (_openBlock(), _createBlock(_component_IconArrowLeft, {
                    key: 0,
                    onClick: _ctx.onGoBack
                  }, null, 8, ["onClick"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (_ctx.vue_app_theme === _ctx.THEMES)
                      ? (_openBlock(), _createBlock(_component_IconLogo, {
                          key: 0,
                          onClick: _ctx.onGoToHomepage
                        }, null, 8, ["onClick"]))
                      : (_openBlock(), _createBlock(_component_IconLogoTapi, {
                          key: 1,
                          onClick: _ctx.onGoToHomepage
                        }, null, 8, ["onClick"]))
                  ]))
            ]),
            (_ctx.isAuth)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "hm__elm-profile",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickProfile && _ctx.onClickProfile(...args)))
                }, [
                  _createVNode(_component_IconProfile)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isAuth)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_IconProfile),
                  (_ctx.currentRoute === _ctx.LOGIN)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickLogin && _ctx.onClickLogin(...args))),
                        class: "hm__elm-profile-link"
                      }, " Войти "))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowSearch)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_IconArrowLeft, { onClick: _ctx.onHideSearch }, null, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_IconInputSearch, { class: "hm__appear-search-icon" })
            ])
          ]))
        : _createCommentVNode("", true)
    ], 4),
    (_ctx.modalNotify.isShow)
      ? (_openBlock(), _createBlock(_component_ModalHeaderNotify, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.modalProfile.isShow)
      ? (_openBlock(), _createBlock(_component_ModalBottomProfile, {
          key: 1,
          channels: _ctx.channels,
          "tariff-type": _ctx.tariffType
        }, null, 8, ["channels", "tariff-type"]))
      : _createCommentVNode("", true)
  ], 64))
}